__turbopack_context__.v({
  "label": "KZ1Baq_label",
  "root": "KZ1Baq_root",
  "section": "KZ1Baq_section",
});
